/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { MyLibraryCandidateDropDownFilterViewModel } from "../types/MyLibraryCandidateDropDownFilterViewModel.ts";

export const myLibraryCandidateDropDownFilterViewModelSchema = z.object({
  classStudentIds: z
    .array(z.number().int())
    .describe(
      "IDs das turmas a filtrar. Lista vazia considera todas as turmas. Opcional.",
    )
    .nullish(),
  filter: z
    .string()
    .describe(
      "Texto de busca aplicado ao nome da pessoa. A comparação ignora maiúsculas e minúsculas. Opcional.",
    )
    .nullish(),
}) as unknown as ToZod<MyLibraryCandidateDropDownFilterViewModel>;
